/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { DefaultReactions } from '../../shared/constants';
import { EmojiButton } from '../EmojiButton';
import { ShowMore } from '../ShowMore';
import { revealStyle } from './styles';

/**
 * Test id for wrapper Selector div
 */
export const RENDER_SELECTOR_TESTID = 'render-selector';

/**
 * Delay for each emoji reveal animation, in ms
 */
const REVEAL_DELAY = 50;
const containerStyles = xcss({
  padding: 'space.050'
});
const separatorStyles = xcss({
  borderLeftColor: 'color.border',
  borderLeftStyle: 'solid',
  borderLeftWidth: 'border.width',
  marginInlineStart: 'space.050',
  marginInlineEnd: 'space.100',
  height: '24px',
  display: 'inline-block'
});
const Reveal = ({
  children,
  delay,
  testId
}) => {
  return jsx("div", {
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
    ,
    css: revealStyle
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: delay ? {
      animationDelay: `${delay}ms`
    } : undefined
  }, children);
};

/**
 * Reactions picker panel part of the <ReactionPicker /> component
 */
export const Selector = ({
  emojiProvider,
  onMoreClick,
  onSelection,
  showMore,
  pickerQuickReactionEmojiIds = DefaultReactions
}) => {
  /**
   * Render the default emoji icon
   * @param emoji emoji item
   * @param index location of the emoji in the array
   */
  const renderEmoji = (emoji, index) => {
    var _emoji$id;
    return jsx(Reveal, {
      delay: index * REVEAL_DELAY,
      key: (_emoji$id = emoji.id) !== null && _emoji$id !== void 0 ? _emoji$id : emoji.shortName,
      testId: RENDER_SELECTOR_TESTID
    }, jsx(Tooltip, {
      content: emoji.shortName
    }, jsx(EmojiButton, {
      emojiId: emoji,
      emojiProvider: emojiProvider,
      onClick: onSelection
    })));
  };
  return jsx(Inline, {
    alignBlock: "center",
    xcss: containerStyles
  }, pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null, showMore ? jsx(Fragment, null, jsx(Box, {
    xcss: separatorStyles
  }), jsx(Reveal, {
    delay: DefaultReactions.length * REVEAL_DELAY
  }, jsx(ShowMore, {
    key: "more",
    onClick: onMoreClick
  }))) : null);
};